const baseStyle = {
    container: { borderRadius: "24px", textTransform: "uppercase" },
};
const sizes = {
    s: {
        container: {
            minW: "59px",
            minH: "28px",
            fontSize: "xs",
            fontWeight: 500,
            lineHeight: "20px",
            letterSpacing: "1.5px",
            px: 3,
            py: 1,
        },
    },
    xs: {
        container: {
            minW: "44px",
            minH: "23px",
            fontSize: "10px",
            fontWeight: 700,
            lineHeight: "15px",
            letterSpacing: "0.5px",
            px: 2,
            py: 1,
        },
    },
};
const variants = {
    primary: ({ colorScheme }) => ({
        container: {
            color: "greyscale.100",
            bg: colorScheme === "info" ? `${colorScheme.replace("info", "primary")}.400` : `${colorScheme}.500`,
        },
    }),
    secondary: ({ colorScheme }) => ({
        container: {
            bg: colorScheme === "info" ? `${colorScheme.replace("info", "primary")}.100` : `${colorScheme}.200`,
            color: colorScheme === "info" ? `${colorScheme.replace("info", "primary")}.400` : `${colorScheme}.500`,
        },
    }),
    tertiary: ({ colorScheme }) => ({
        container: {
            border: "1px solid",
            borderColor: colorScheme === "info" ? `${colorScheme.replace("info", "primary")}.400` : `${colorScheme}.500`,
            color: colorScheme === "info" ? `${colorScheme.replace("info", "primary")}.400` : `${colorScheme}.500`,
            bg: `${colorScheme.replace("info", "primary")}.100`,
        },
    }),
    quaternary: ({ colorScheme }) => ({
        container: {
            bg: "none",
            color: colorScheme === "info" ? `${colorScheme.replace("info", "primary")}.400` : `${colorScheme}.500`,
        },
    }),
};
const defaultProps = {
    size: "s",
    colorScheme: "info",
    variant: "primary",
};
const Tag = {
    variants,
    baseStyle,
    sizes,
    defaultProps,
};
export default Tag;
